const convertirFloat = (number: number) => {
  return number.toFixed(2);
};

export { convertirFloat };
